import React from "react";
import { Link } from "react-router-dom";
import { Brain } from "lucide-react";

// iter130 Phase A — legal placeholders. These are stub pages so the
// signup consent checkbox's links resolve. Real copy will be dropped
// in before public launch (comes from user's legal counsel).
export default function LegalPage({ title, sections }) {
  return (
    <div className="min-h-screen bg-[var(--bt-bg)] text-[var(--bt-text)]">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[var(--bt-text-muted)] hover:text-[var(--bt-accent)] mb-8">
          <Brain className="w-4 h-4" /> Back to BrainTRADES
        </Link>
        <h1 className="font-heading text-4xl mb-2">{title}</h1>
        <p className="text-xs uppercase tracking-widest text-[var(--bt-text-muted)] mb-8">
          Placeholder — final text pending legal review
        </p>
        <div className="space-y-6 text-sm leading-relaxed text-[var(--bt-text)]">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-heading text-lg mb-2">{s.h}</h2>
              <p className="text-[var(--bt-text-muted)]">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      sections={[
        { h: "1. Acceptance of Terms", p: "By creating an account you agree to these terms. This is a placeholder — final legal copy will replace this text before public launch." },
        { h: "2. Trading Journal (not financial advice)", p: "BrainTRADES is a personal-analytics tool for reviewing your own trading. Nothing shown in the app constitutes financial advice, a recommendation, or a solicitation to trade any instrument." },
        { h: "3. Your account", p: "You are responsible for keeping your credentials confidential. If you connect a broker API (read-only recommended), you are responsible for the scope of access you grant." },
        { h: "4. Subscription and billing", p: "Paid tiers unlock additional features. Details of pricing, billing, refunds, and cancellation appear on our pricing page." },
        { h: "5. Data ownership", p: "Your trade data belongs to you. You can export it at any time. See our Privacy Policy for how we store and process it." },
        { h: "6. Changes", p: "We may update these terms with 30 days notice via email. Continued use after the effective date constitutes acceptance." },
      ]}
    />
  );
}

export function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      sections={[
        { h: "1. What we collect", p: "Email, name, phone (optional), your trade data, and technical logs. Placeholder — final DPDP-compliant copy pending legal review." },
        { h: "2. Why we collect it", p: "To provide the journal service, verify your identity, deliver password-reset and sign-in emails, and give you support." },
        { h: "3. Storage and encryption", p: "Data lives on MongoDB Atlas with AES-256 at-rest encryption and TLS in transit. We never sell, rent, or share your data with third parties for advertising." },
        { h: "4. Third-party processors", p: "Resend (transactional emails), MSG91 (phone OTPs), Google Sign-In (optional), Razorpay (payments). Each is used strictly for the purpose stated above." },
        { h: "5. Your rights (DPDP Act)", p: "You can access, correct, or delete your data by writing to support@braintrades.com. We respond within 15 working days." },
        { h: "6. Retention", p: "We keep your data as long as your account is active. If you delete your account, we purge trade data within 30 days and retain only the minimum required by tax law for billing records." },
      ]}
    />
  );
}
